import { Box, Stack } from "@mui/material";
import StoreBadge from "./StoreBadge";
import StoreQrCode from "./StoreQrCode";
import { storePlatform } from "../helpers/storePlatform";

/**
 * Where to get the Echo app, for the device in hand: an Android phone gets
 * Google Play, an iPhone gets the App Store, and anything else gets a QR code
 * per store to scan with a phone.
 *
 * `labels`: `{ googlePlay, appStore, qrGooglePlay, qrAppStore }`.
 */
const AppStoreLinks = ({ labels }) => {
  const platform = storePlatform();

  return (
    <Box data-store-platform={platform}>
      {platform === "android" && (
        <StoreBadge store="googlePlay" alt={labels.googlePlay} />
      )}
      {platform === "ios" && (
        <StoreBadge store="appStore" alt={labels.appStore} />
      )}
      {platform === "other" && (
        <Stack direction="row" justifyContent="center" flexWrap="wrap" gap={4}>
          <Stack alignItems="center" gap={1.5}>
            <StoreQrCode store="googlePlay" title={labels.qrGooglePlay} />
            <StoreBadge store="googlePlay" alt={labels.googlePlay} />
          </Stack>
          <Stack alignItems="center" gap={1.5}>
            <StoreQrCode store="appStore" title={labels.qrAppStore} />
            <StoreBadge store="appStore" alt={labels.appStore} />
          </Stack>
        </Stack>
      )}
    </Box>
  );
};

export default AppStoreLinks;
